export function schema_share_document() {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			mode: {
				type: "string",
				title: "Mode",
				enum: ["fichiers", "csv"],
				default: "fichiers",
			},
			action: {
				type: "string",
				title: "Action",
				enum: ["Ajouter ou mettre à jour", "Supprimer"],
				default: "Ajouter ou mettre à jour",
			},
			folder: {
				type: "string",
				title: "Dossier",
			},
			url: {
				type: "string",
				title: "Colonne url (si csv)",
			},
			name: {
				type: "string",
				title: "Colonne des noms (si csv)",
			},
			column_uid: {
				type: "string",
				title: "Colonne des uid (si csv)",
				default: "",
			},
			return_files: {
				type: "boolean",
				title: "Renvoi des fichiers (si csv)",
				format: "checkbox",
			},
			public: {
				type: "boolean",
				title: "Public",
				format: "checkbox",
			},
			no_thumbnail: {
				type: "boolean",
				title: "Ne pas générer de miniature",
				format: "checkbox",
			},
		},
	};
}
